import React from "react"

const UnstyledLayout = ({ children }) => {
  return (
    <div className={`unstyled-page`}>{children}</div>
  )
}

export default UnstyledLayout
